import { ListingItemProps } from "./types";
import { BookListingItem } from "./BookListingItem";
import { ProductBundleListingItem } from "./ProductBundleListingItem";
import { SubscriptionListingItem } from "./SubscriptionListingItem";
import { ContributorListingItem } from "./ContributorListingItem";
import { LiteraryWorkListingItem } from "./LiteraryWorkListingItem";
import { SeriesListingItem } from "./SeriesListingItem";
import { DigitalServiceListingItem } from "./DigitaleServiceItem";
import { ArticleListingItem } from "./ArticleListingItem";
import { IndexDocument } from "@cappelendamm/catalogue/meilisearch/search-index-receiver.js";

export function ListingItem({ item, config }: ListingItemProps<IndexDocument>) {
  if (item.itemType === "book")
    return <BookListingItem item={item} config={config} />;
  if (item.itemType === "product-bundle")
    return <ProductBundleListingItem item={item} config={config} />;
  if (item.itemType === "subscription")
    return <SubscriptionListingItem item={item} config={config} />;
  if (item.itemType === "contributor")
    return <ContributorListingItem item={item} config={config} />;
  if (item.itemType === "literary-work")
    return <LiteraryWorkListingItem item={item} config={config} />;
  if (item.itemType === "series")
    return <SeriesListingItem item={item} config={config} />;
  if (item.itemType === "digital-service")
    return <DigitalServiceListingItem item={item} config={config} />;
  if (item.itemType === "article")
    return <ArticleListingItem item={item} config={config} />;
  return null;
}
